"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _SortableItem = _interopRequireDefault(require("./components/SortableItem/SortableItem"));

var _Item = _interopRequireDefault(require("./components/Item/Item"));

var sc = _interopRequireWildcard(require("./Sortable.styles"));

var propTypes = {
  children: _propTypes["default"].node,

  /** Indicator to identify the number sequence  */
  hasNumbers: _propTypes["default"].bool,

  /** Add a background-color to all even rows */
  hasZebraStripes: _propTypes["default"].bool,

  /** Callback when sorting */
  onChange: _propTypes["default"].func.isRequired,

  /** Callback when deleting an item */
  onRemove: _propTypes["default"].func
};
var defaultProps = {
  children: null,
  hasNumbers: true,
  hasZebraStripes: false,
  onRemove: null
};

function filterChildren(children) {
  return _react["default"].Children.toArray(children).filter(function (child) {
    return child.type.displayName === "Sortable.Item";
  });
}

var Sortable = function Sortable(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      hasNumbers = _ref.hasNumbers,
      hasZebraStripes = _ref.hasZebraStripes,
      onRemove = _ref.onRemove,
      moreProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "onChange", "hasNumbers", "hasZebraStripes", "onRemove"]);
  var I18n = (0, _useI18n["default"])();

  var _React$useState = _react["default"].useState(function () {
    return "droppable_".concat((0, _uuid.v4)());
  }),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 1),
      dropId = _React$useState2[0];

  var validChildren = filterChildren(children);

  var handleDragStart = function handleDragStart(start, provided) {
    var source = start.source;
    provided.announce(I18n.t("sortable.aria_lift", {
      source: source.index + 1
    }));
  };

  var handleDragUpdate = function handleDragUpdate(update, provided) {
    var source = update.source,
        destination = update.destination;

    if (destination) {
      provided.announce(I18n.t("sortable.aria_moving", {
        source: source.index + 1,
        destination: destination.index + 1
      }));
    } else {
      provided.announce(I18n.t("sortable.aria_moving_outside"));
    }
  };

  var handleDragEnd = function handleDragEnd(result, provided) {
    var source = result.source,
        destination = result.destination;
    onChange({
      source: source.index,
      destination: destination ? destination.index : null
    });

    if (destination) {
      provided.announce(I18n.t("sortable.aria_dropped", {
        source: source.index + 1,
        destination: destination.index + 1
      }));
    } else {
      provided.announce(I18n.t("sortable.aria_dropped_outside", {
        source: source.index + 1
      }));
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: handleDragEnd,
    onDragStart: handleDragStart,
    onDragUpdate: handleDragUpdate,
    liftInstruction: I18n.t("sortable.aria_description")
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: dropId
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement(sc.Sortable, (0, _extends2["default"])({}, provided.droppableProps, moreProps, {
      hasZebraStripes: hasZebraStripes,
      "data-pka-anchor": "sortable",
      "data-is-dragging-over": snapshot.isDraggingOver ? true : undefined,
      isDraggingOver: snapshot.isDraggingOver,
      ref: provided.innerRef
    }), validChildren.length > 0 && validChildren.map(function (child, index) {
      return /*#__PURE__*/_react["default"].createElement(_SortableItem["default"], (0, _extends2["default"])({
        key: child.props.sortId,
        index: index,
        hasNumbers: hasNumbers,
        onRemove: onRemove
      }, child.props), child);
    }), provided.placeholder);
  }));
};

Sortable.displayName = "Sortable";
Sortable.propTypes = propTypes;
Sortable.defaultProps = defaultProps;
Sortable.Item = _Item["default"];
var _default = Sortable;
exports["default"] = _default;
//# sourceMappingURL=Sortable.js.map